module.exports = ".P {page-break-after: always}\r\n.THEAD{ display: table-header-group; }\r\n\r\n#traconContent THEAD TR {\r\n\t   BACKGROUND: #fff;\r\n\t\tCOLOR: #000;\r\n\t }\r\n#traconContent THEAD TR TH{\r\n\t\t FONT-WEIGHT: bold;\r\n\t\t FONT-SIZE:20px;\r\n\t\t COLOR: #fff;\r\n\t\tTEXT-ALIGN: center;\r\n\t  }\r\n#traconContent THEAD TR TD{\r\n\t\t FONT-SIZE: 12px;\r\n\t\t BACKGROUND: #e93f3f;\r\n\t\t COLOR: #fff;\r\n\t   }\r\n#traconContent TBODY TD{\r\n\t\t  BACKGROUND: #fff;\r\n\t\t FONT-SIZE: 9px;\r\n\t   }\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./app/system-management/tracon-models/tracon-model.css
 ** module id = 861
 ** module chunks = 0
 **/